var image_viewer_default = {
  "fontElementMap": "Ms-6V",
  "imageContainer": "c1lam",
  "expandButton": "l3D2n",
  "expandIcon": "x4X9u",
  "pointer": "tyLXc",
  "imageWrapper": "_9mTCm",
  "imageRatio": "nR3DR",
  "image": "_8eZbP",
  "imageOverlay": "_4UF0S",
  "imagePreload": "-WNPX",
  "imageHighres": "h687L",
  "onlyHighRes": "qUdk-",
  "image_loading": "Qj-wX"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
